import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "phone", "submit", "message"]

  connect() {
    this.update()
  }

  update() {
    const hasDestination = this.emailTarget.value.trim() !== "" || this.phoneTarget.value.trim() !== ""

    this.submitTarget.disabled = !hasDestination

    if (this.hasMessageTarget) {
      this.messageTarget.classList.toggle("text-danger", !hasDestination)
    }
  }
}
